import React from "react";

const DashboardShape2 = () => {
	return (
		<svg width="464" height="675" viewBox="0 0 464 675" fill="none">
			<g filter="url(#filter0_f_31_333)">
				<path
					d="M281.308 463.221C350.237 493.926 430.825 462.53 461.307 393.097C491.789 323.663 460.622 242.484 391.692 211.779C322.764 181.074 242.175 212.469 211.693 281.903C181.211 351.337 212.379 432.516 281.308 463.221Z"
					fill="url(#paint0_radial_31_333)"
					fillOpacity="0.7"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_31_333"
					x="0"
					y="0"
					width="673"
					height="675"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation="100"
						result="effect1_foregroundBlur_31_333"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_31_333"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(601.289 505.781) rotate(-154.276) scale(631.533 576.099)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default DashboardShape2;
